var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-btn',{attrs:{"color":"teal","loading":_vm.loading,"block":_vm.block,"text":_vm.$t('common.import'),"icon":"mdi-import"},on:{"press":_vm.press}})}
var staticRenderFns = []

export { render, staticRenderFns }